// One Pending Deployments row is one deployment REQUEST (Batch161), not one
// order: the lines of an order that share a Start Date AND a guard service.
// Day + Night of General Guarding starting the same day are one request; a
// different date, or a different service on the same day, is another. So the
// same order can appear more than once, and a row is only unique by all three.
//
// A row with no serviceTypeId is an order with no deployment-line rows at all
// (none exist today; the proc returns it whole, defensively) - it stands for
// every line on the order.

export const dateOnly = (d) => (d ? String(d).slice(0, 10) : "");

export const requestKey = (r) => `${r.recordGuid}|${dateOnly(r.requestedDeploymentDate)}|${r.serviceTypeId ?? ""}`;

export const isWholeOrderRequest = (r) => r?.serviceTypeId == null;

// The order's lines that make up this request. Falls back to every line if
// none match, so a screen never ends up with nothing to show or act on.
export const linesForRequest = (lines, request) => {
  if (!request || isWholeOrderRequest(request)) return lines;
  const date = dateOnly(request.requestedDeploymentDate);
  const matched = lines.filter(
    (l) => dateOnly(l.startDate) === date && Number(l.serviceTypeId) === Number(request.serviceTypeId)
  );
  return matched.length ? matched : lines;
};

// "Day", "Night" or "Day + Night" for a set of lines.
export const shiftLabel = (lines) => {
  const shifts = [...new Set(lines.map((l) => (l.shift === "NIGHT" ? "Night" : "Day")))];
  return shifts.sort().join(" + ");
};
